._container_1qeuy_1 {
  margin: 0 auto; }

._text_1qeuy_4 {
  padding-top: 6px;
  max-width: unset !important; }

._paragraph_1qeuy_8 {
  padding-bottom: 12px; }
